
import { auto } from '@popperjs/core';
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Mousewheel } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel]);


class VideoGallery {

    videoGalleryContainer: NodeListOf<HTMLElement> = document.querySelectorAll('.pl-video-gallery');
    swiperVidoes: NodeListOf<HTMLElement> = document.querySelectorAll('.swiper-videos');
    isCarousel: boolean = false;
    constructor() {
        this.init();
    }

    init() {

        this.swiperVidoes.forEach((swiperEl) => {
            const thumbnailCount = swiperEl.querySelectorAll('.swiper-slide').length;
            this.isCarousel = thumbnailCount > 2;

            if (!this.isCarousel) {
                swiperEl.parentElement?.classList.add('no-carousel');
                swiperEl.parentElement?.parentElement?.classList.add('no-carousel');

            } else {
                const swiperInstance = new Swiper(swiperEl, {
                    modules: [Navigation, Pagination, Scrollbar, Mousewheel],
                    loop: false,
                    slidesPerView: this.isCarousel ? 'auto' : 2, 
                    spaceBetween: 24,
                    scrollbar: {
                        hide: !this.isCarousel,
                        el: swiperEl.querySelector('.swiper-scrollbar') as HTMLElement,
                        draggable: true,
                        dragSize: auto,
                        snapOnRelease: true,
                    },
                    mousewheel: {
                        forceToAxis: true,
                        sensitivity: 1,
                    },
                    breakpoints: {
    
                        1200: { 
                            scrollbar: {
                                dragSize: auto
                            }
                        },
                        1400: { 
                            scrollbar: {
                                dragSize: auto
                            }
                         },
                    },
                    on: {
                        init(this: Swiper) {
                            setTimeout(() => equalizeSlideHeights(this.el), 50);
                        },
    
                        slideChangeTransitionStart(this: Swiper) {
                            const prevIndex = this.previousIndex;
                            const activeIndex = this.activeIndex;
                            const realLength = this.slides.length;
    
                            const isLoopingForward =
                                (activeIndex > prevIndex && !(activeIndex === 0 && prevIndex === realLength - 1)) ||
                                (activeIndex === 0 && prevIndex > activeIndex);
    
                            if (isLoopingForward) {
                                const prevSlide = this.slides[prevIndex] as HTMLElement | undefined;
                                if (prevSlide) {
                                    prevSlide.classList.add('fading-out');
                                    void prevSlide.offsetWidth;
                                    setTimeout(() => {
                                        prevSlide.classList.remove('fading-out');
                                    }, 250);
                                }
                            } else {
                                // Backward nav: fade in the current slide
                                const activeSlide = this.slides[activeIndex] as HTMLElement | undefined;
                                if (activeSlide) {
                                    activeSlide.classList.add('fading-in');
                                    activeSlide.classList.remove('fading-in-active'); // reset just in case
    
                                    // Force reflow, then trigger fade-in transition
                                    void activeSlide.offsetWidth;
    
                                    // Now trigger the fade-in transition
                                    activeSlide.classList.add('fading-in-active');
    
                                    // Clean up
                                    setTimeout(() => {
                                        activeSlide.classList.remove('fading-in');
                                        activeSlide.classList.remove('fading-in-active');
                                    }, 250);
                                }
                            }
                        },
    
                        slideChangeTransitionEnd(this: Swiper) {
                            equalizeSlideHeights(this.el);
                        },
                    }
                });
            }
            swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {

                const button = slide.querySelector('button.pl-card');
                const img = button?.querySelector('img');
                if (button && img && !img.getAttribute('src')) {
                    const videoUrl = button.getAttribute('data-video-url');
                    const match = videoUrl && videoUrl.match(/embed\/([a-zA-Z0-9_-]+)/);
                    if (match) {
                        img.src = `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
                    }
                }

                slide.addEventListener('click', () => {
                    if (slide.classList.contains('selected')) {
                        return;
                    }

                    const button = slide.querySelector('button.pl-card');

                    const videoTitle = button.getAttribute('data-video-title') || '';
                    const videoEmbed = button.getAttribute('data-video-url') || '';
                    const videoDescription = button.getAttribute('data-video-description') || '';

                    const plVideoGallery = swiperEl.closest('.pl-video-gallery');
                    if (!plVideoGallery) return;

                    const featuredVideoTitle = plVideoGallery.querySelector('.featured-video-title') as HTMLElement | null;
                    const featuredVideoIframe = plVideoGallery.querySelector('iframe') as HTMLIFrameElement | null;
                    const featuredVideoDescription = plVideoGallery.querySelector('.featured-video-description') as HTMLElement | null;

                    if (featuredVideoTitle) {
                        featuredVideoTitle.textContent = videoTitle;
                    }
                    if (featuredVideoIframe) {
                        featuredVideoIframe.src = videoEmbed;
                    }
                    if (featuredVideoDescription) {
                        featuredVideoDescription.textContent = videoDescription;
                    }

                    // unselect all slides
                    swiperEl.querySelectorAll('.swiper-slide.selected').forEach((s) => {
                        s.classList.remove('selected');
                    });
                    // select clicked slide
                    slide.classList.add('selected');
                });
            })
        });

        this.videoGalleryContainer.forEach((videoGallery) => {
            const firstSlide = videoGallery.querySelectorAll('.swiper-slide, .card-wrapper')[0];
            if (!firstSlide) return;

            const button = firstSlide.querySelector('button.pl-card');

            const videoTitle = button.getAttribute('data-video-title') || '';
            const videoEmbed = button.getAttribute('data-video-url') || '';
            const videoDescription = button.getAttribute('data-video-description') || '';
           
            const featuredVideoTitle = videoGallery.querySelector('.featured-video-title') as HTMLElement | null;
            const featuredVideoIframe = videoGallery.querySelector('iframe') as HTMLIFrameElement | null;
            const featuredVideoDescription = videoGallery.querySelector('.featured-video-description') as HTMLElement | null;

            if (featuredVideoTitle) {
                featuredVideoTitle.textContent = videoTitle;
            }
            if (featuredVideoIframe) {
                featuredVideoIframe.src = videoEmbed;
            }
            if (featuredVideoDescription) {
                featuredVideoDescription.textContent = videoDescription;
            }

            firstSlide.classList.add('selected');

        });

        window.onload = () => {

        }
    }

    equalizeSlideHeights(container: HTMLElement | null): void {
        if (!container) return;

        const wrapper = container.querySelector('.swiper-wrapper') as HTMLElement | null;
        const slides = container.querySelectorAll<HTMLElement>('.swiper-slide');

        if (!wrapper || slides.length === 0) return;

        // Temporarily remove Swiper transform to get accurate height
        const originalTransform = wrapper.style.transform;
        wrapper.style.transform = 'none';

        // Reset heights
        slides.forEach(slide => {
            slide.style.height = 'auto';
        });

        // Determine the tallest slide
        let maxHeight = 0;
        slides.forEach(slide => {
            maxHeight = Math.max(maxHeight, slide.scrollHeight);
        });

        // Apply uniform height
        slides.forEach(slide => {
            slide.style.height = `${maxHeight}px`;
        });

        // Restore Swiper transform
        wrapper.style.transform = originalTransform;
    }


}

export default VideoGallery;

function equalizeSlideHeights(el: HTMLElement): void {
    if (!el) return;

    const wrapper = el.querySelector('.swiper-wrapper') as HTMLElement | null;
    const slides = el.querySelectorAll<HTMLElement>('.swiper-slide');

    if (!wrapper || slides.length === 0) return;

    // Temporarily remove Swiper transform to get accurate height
    const originalTransform = wrapper.style.transform;
    wrapper.style.transform = 'none';

    // Reset heights
    slides.forEach(slide => {
        slide.style.height = 'auto';
    });

    // Determine the tallest slide
    let maxHeight = 0;
    slides.forEach(slide => {
        maxHeight = Math.max(maxHeight, slide.scrollHeight);
    });

    // Apply uniform height
    slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
    });

    // Restore Swiper transform
    wrapper.style.transform = originalTransform;
}

